import Dictionary from "./Dictionary";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Dictionary />
      <footer className="App-footer">
        <a
          href="https://github.com/lch0711/react-dictionary-app"
          target="_blank"
          rel="noreferrer"
        >
          Open-Source Code
        </a>{" "}
        by Lai Shuan Chung
      </footer>
    </div>
  );
}

export default App;
